import { IoMdLogOut } from 'react-icons/io';
import styles from '../../assets/styles/Admin/AdminShell.module.scss';
import { adminStore } from '../../stores';
import MimaText from '../MimaText';
import AdminSidebar from './AdminSidebar';
import { GiHamburgerMenu } from 'react-icons/gi';
import { useState } from 'react';
import { MimaButton } from '../Button';
import { AnimatePresence } from 'framer-motion';
import LogoutModal from '../LogoutModal/LogoutModal';

export const AdminShell = ({
	children,
	pageTitle,
	childClassName,
	actionButton,
}) => {
	const { adminUser } = adminStore;
	const { firstname } = adminUser;
	const [showSidebar, setShowSidebar] = useState(false);

	const menuClicked = () => {
		setShowSidebar(!showSidebar);
	};

	const [openModal, setOpenModal] = useState('');

	const openModalHandler = modal => {
		setOpenModal(modal);
	};

	const modalConstant = {
		logout: 'LOGOUT',
		dispute: 'DISPUTE',
		subscription: 'SUBSCRIPTION',
	};

	const closeModal = () => {
		setOpenModal('');
	};

	const goTologout = () => {
		openModalHandler(modalConstant.logout);
	};

	const actionButtons = Array.isArray(actionButton)
		? actionButton.filter(button => button?.title)
		: actionButton?.title
			? [actionButton]
			: [];

	return (
		<main className={styles.main}>
			<AdminSidebar showSidebar={showSidebar} menuClicked={menuClicked} />
			<div className={styles.ghost} />
			<div className={styles.body}>
				<header className={styles.header}>
					<div className={styles.header__a}>
						<GiHamburgerMenu size={20} onClick={menuClicked} />
						<MimaText variant="subtitleBold">{pageTitle}</MimaText>
					</div>
					<IoMdLogOut size={20} onClick={goTologout} />
				</header>
				<div className={styles.header__bottom}>
					{' '}
					<MimaText variant="bodyBold">Hello {firstname},</MimaText>
					{actionButtons.length > 0 && (
						<div className={styles.btns}>
							{actionButtons.map((button, index) => (
								<MimaButton
									key={`${button?.title}-${index}`}
									buttonColor="var(--color-fash-black)"
									{...button}
									variant="colorableSmall"
								/>
							))}
						</div>
					)}
				</div>

				<div className={`${styles.children} ${childClassName}`}>{children}</div>
			</div>
			{openModal !== '' && (
				<div className="modal">
					<AnimatePresence>
						{openModal === modalConstant.logout && (
							<LogoutModal closeModal={closeModal} />
						)}
					</AnimatePresence>
				</div>
			)}
		</main>
	);
};

export default AdminShell;
